const junkNames = ['abc', 'acme', 'adf', 'admin', 'asd', 'asdf', 'co name', 'college', 'company', 'company name', 'confidential',
    'consultant', 'consulting', 'contact', 'contractor', 'customer', 'default', 'demo', 'false', 'freelance', 'freelancer',
    'home', 'home office', 'independant', 'independant consultant', 'independent', 'independent consultant', 'individual',
    'internet marketing company', 'it', 'it conlsultant', 'me', 'my', 'myself', 'na', 'name', 'no', 'no company', 'no name yet',
    'nocompany', 'non', 'none', 'not provided', 'null', 'other', 'personal', 'privat', 'private', 'qwe', 'qwer', 'qwert',
    'qwerty', 'qwertyu', 'retired', 'self', 'self employed', 'student', 'system', 'tbd', 'test', 'test inc', 'testing',
    'true', 'undisclosed', 'unemployed', 'university', 'unk', 'unknown', 'valued', 'xxx', 'xyz'];

export const IsJunkName = function (name: string): boolean {
    let junkNameDetected = false;
    name = name.replace(/[\.,-\/#!$%\^&\*;:{}=\-_`~()|]/g, "").replace(/\s{2,}/g, " ").toLowerCase();
    if (name != null && name.length > 1) {
        for (var i = 0; i < junkNames.length; i++) {
            try {
                var regX = junkNames[i].replace(/[\.,-\/#!$%\^&\*;:{}=\-_`~()|]/g, "").replace(/\s{2,}/g, " ").toLowerCase();
                if (regX === name) {
                    junkNameDetected = true;
                    break;
                }
            } catch (e) {
                junkNameDetected = false;
            }
        } // end loop
    } else {
        junkNameDetected = true;
    }
    return junkNameDetected;
}